var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('highlight-video-data',{attrs:{"form-import":_vm.form,"valid-countries":_vm.validCountries,"categories":_vm.categories,"loading":_vm.loading,"errors-import":_vm.errors},on:{"requestData":_vm.requestCreateHighlightVideo}})}
var staticRenderFns = []

export { render, staticRenderFns }